module.exports = __webpack_public_path__ + "static/media/amount.aae6f08c.png";


//////////////////
// WEBPACK FOOTER
// ./src/style/imgs/all/amount.png
// module id = 683
// module chunks = 1